import { useEffect } from 'react'
import QuestionnaireAssignment from '../../../../../libs/api/services/QuestionnaireAssignment'

export default function QuestionnaireAssignmentAssignedCheck({ title, description, navigation, errors, setValue, values, forceStep }) {
  useEffect(() => {

    title('')
    description('')
    navigation([])
    const checkAssigned = async () => {
      if ((await QuestionnaireAssignment.GetPatientQuestionnaires(values.user.id)).filter(q => q.questionnaire.id === values.questionnaire.id && !q.completedDate).length > 0) {
        title('Already Assigned')
        description('There is already an incomplete questionnaire assigned to this patient')
        navigation([{ text: 'Continue Assignment', type: 'Step', step: 3, action: async () => { } }])
      } else {
        forceStep(3)
      }
    }
    checkAssigned()
  }, [])
}
